module.exports = __webpack_public_path__ + "static/media/part-detail-slide-7.fff486a1.jpg";